module.exports = __webpack_public_path__ + "img/imagen3.bd87593a.png";